export type PreviewMode = "light" | "dark";

export const PREVIEW_MODES: ReadonlyArray<{
  value: PreviewMode;
  label: string;
}> = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];
